import { type FC } from "react";
import { Icon } from "../../ui";
import styles from "./AdminDashboardHeader.module.scss";
import Spacing from "../../ui/Spacing";
import { NavLink, useNavigate } from "react-router-dom";
import { getUser } from "@/store/slices/auth";
import { useAppSelector } from "@/store/hooks";
import { extractNameFromEmail } from "@/core";
interface AdminDashboardHeaderProps {
  isRightSectionShown: boolean;
}
const AdminDashboardHeader: FC<AdminDashboardHeaderProps> = ({
  isRightSectionShown = true,
}) => {
  const navigate = useNavigate();
  const user = useAppSelector(getUser);
  const handleProfile = () => {
    navigate("/dashboard/profile/admin");
  };
  const handleNotification = () => {
    navigate("/dashboard/notification");
  };
  return (
    <header className={styles.sobDashboardHeader}>
      <div className={styles.container}>
        <div className={styles.logo}>
          <img
            src="https://res.cloudinary.com/dv9u0wicr/image/upload/v1745691478/SOB_Images/aceb4t4qoi1beu2gd0oi.png"
            alt=""
            className={styles["logo--img"]}
          />
        </div>
        {isRightSectionShown && (
          <div className={styles.rightSection}>
            <Spacing display="flex" justify="center" align="center">
              <Icon
                name={"icon-notifications"}
                size={20}
                onClick={handleNotification}
              />
            </Spacing>
            <Spacing>
              <div className={styles.profileWrapper} onClick={handleProfile}>
                <img
                  src={
                    user?.profileImage ||
                    "	https://res.cloudinary.com/dv9u0wicr/image/upload/v1766336072/Group_c7w8bu.png"
                  }
                  alt=""
                  className={styles.profileImg}
                />
                <NavLink
                  to={"/dashboard/profile/admin"}
                  className={({ isActive }) =>
                    isActive ? styles.activeUserText : styles.userText
                  }
                >
                  {extractNameFromEmail(user?.email as string)}
                </NavLink>
              </div>
            </Spacing>
          </div>
        )}
      </div>
    </header>
  );
};

export default AdminDashboardHeader;
